var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97, _symbol98, _symbol99, _symbol100, _symbol101, _symbol102, _symbol103, _symbol104, _symbol105, _symbol106, _symbol107, _symbol108, _symbol109, _symbol110, _symbol111, _symbol112, _symbol113, _symbol114, _symbol115, _symbol116, _symbol117, _symbol118, _symbol119, _symbol120, _symbol121, _symbol122, _symbol123, _symbol124, _symbol125, _symbol126, _symbol127, _symbol128, _symbol129, _symbol130, _symbol131, _symbol132, _symbol133, _symbol134, _symbol135, _symbol136, _symbol137, _defs, _symbol138, _symbol139, _symbol140, _symbol141, _symbol142, _symbol143, _symbol144, _symbol145, _symbol146, _symbol147, _symbol148, _symbol149, _symbol150, _symbol151, _symbol152, _symbol153;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSprites(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "start-dot",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "#D6DADC",
    fillRule: "evenodd"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "billing",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.751 25.753v-.789a.249.249 0 0 1 .373-.217A14.1 14.1 0 0 0 15.6 26.2a1 1 0 0 0 1.153-.957v-.02a.967.967 0 0 0-.81-.982C12.7 23.7 10.751 22.44 10.751 21.5v-.789a.249.249 0 0 1 .373-.217 15.424 15.424 0 0 0 5.687 1.62.959.959 0 0 0 .943-.478l.012-.02a.993.993 0 0 0-.761-1.488c-3.877-.414-6.254-1.843-6.254-2.878v-.786a.25.25 0 0 1 .373-.218A17.574 17.574 0 0 0 19.252 18c2.811.073 5.599-.53 8.129-1.757a.25.25 0 0 1 .373.214c.012.281.008.563-.011.844a.989.989 0 0 0 .524 1.023l.081.04a.965.965 0 0 0 1.4-.86V13c0-3.248-5.41-5-10.5-5S8.764 9.751 8.753 12.993v12.76c0 2.693 3.72 4.354 7.892 4.843a.983.983 0 0 0 1.01-1.406l-.012-.022a1.015 1.015 0 0 0-.784-.548c-3.792-.435-6.108-1.844-6.108-2.867zM19.252 10c5.185 0 8.495 1.773 8.5 3v.009C27.74 14.232 24.433 16 19.252 16s-8.5-1.777-8.5-3 3.311-3 8.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.749 19a6.5 6.5 0 1 0 6.5 6.5 6.508 6.508 0 0 0-6.5-6.5zM24 29.753V29.5a.25.25 0 0 0-.25-.25h-.5a.75.75 0 1 1 0-1.5h2.033a.592.592 0 0 0 .221-1.141l-2.065-.826a2.085 2.085 0 0 1 .361-3.981.249.249 0 0 0 .2-.245v-.307a.75.75 0 1 1 1.5 0v.25c0 .138.112.25.25.25h.5a.75.75 0 1 1 0 1.5h-2.034A.591.591 0 0 0 24 24.393l2.065.826A2.085 2.085 0 0 1 25.7 29.2a.249.249 0 0 0-.2.245v.308a.75.75 0 1 1-1.5 0z"
  })))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "billing-white",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.751 25.753v-.789a.249.249 0 0 1 .373-.217A14.1 14.1 0 0 0 15.6 26.2a1 1 0 0 0 1.153-.957v-.02a.967.967 0 0 0-.81-.982C12.7 23.7 10.751 22.44 10.751 21.5v-.789a.249.249 0 0 1 .373-.217 15.424 15.424 0 0 0 5.687 1.62.959.959 0 0 0 .943-.478l.012-.02a.993.993 0 0 0-.761-1.488c-3.877-.414-6.254-1.843-6.254-2.878v-.786a.25.25 0 0 1 .373-.218A17.574 17.574 0 0 0 19.252 18c2.811.073 5.599-.53 8.129-1.757a.25.25 0 0 1 .373.214c.012.281.008.563-.011.844a.989.989 0 0 0 .524 1.023l.081.04a.965.965 0 0 0 1.4-.86V13c0-3.248-5.41-5-10.5-5S8.764 9.751 8.753 12.993v12.76c0 2.693 3.72 4.354 7.892 4.843a.983.983 0 0 0 1.01-1.406l-.012-.022a1.015 1.015 0 0 0-.784-.548c-3.792-.435-6.108-1.844-6.108-2.867zM19.252 10c5.185 0 8.495 1.773 8.5 3v.009C27.74 14.232 24.433 16 19.252 16s-8.5-1.777-8.5-3 3.311-3 8.5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.749 19a6.5 6.5 0 1 0 6.5 6.5 6.508 6.508 0 0 0-6.5-6.5zM24 29.753V29.5a.25.25 0 0 0-.25-.25h-.5a.75.75 0 1 1 0-1.5h2.033a.592.592 0 0 0 .221-1.141l-2.065-.826a2.085 2.085 0 0 1 .361-3.981.249.249 0 0 0 .2-.245v-.307a.75.75 0 1 1 1.5 0v.25c0 .138.112.25.25.25h.5a.75.75 0 1 1 0 1.5h-2.034A.591.591 0 0 0 24 24.393l2.065.826A2.085 2.085 0 0 1 25.7 29.2a.249.249 0 0 0-.2.245v.308a.75.75 0 1 1-1.5 0z"
  })))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "cursor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.777a3 3 0 0 0 3 3h8.5a1 1 0 1 0 0-2H3a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v7a1 1 0 1 0 2 0v-7a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.223 12.83a.5.5 0 0 0-.67.671l3.724 7.449a.5.5 0 0 0 .932-.1l.6-2.4a.5.5 0 0 1 .364-.364l2.4-.6a.5.5 0 0 0 .1-.932l-7.45-3.724z"
  })))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "global",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.018 19.239a.5.5 0 0 0 .592-.341v-.011a3.275 3.275 0 0 1 6.268 0v.012a.5.5 0 0 0 .591.34 3.255 3.255 0 0 1 2.125.229.479.479 0 0 0 .24-.831L21.028 8.412a1.5 1.5 0 0 0-2.06 0L8.157 18.637a.5.5 0 0 0 .343.863h2a.5.5 0 0 1 .5.5v10a1 1 0 0 0 1 1h5.984a.5.5 0 0 0 .5-.515l-.032-1.089a.513.513 0 0 0-.059-.221 3.272 3.272 0 0 1 .488-3.786l.016-.017a.5.5 0 0 0 0-.68l-.016-.017a3.282 3.282 0 0 1 3.138-5.434l-.001-.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.809 23.97a1.5 1.5 0 1 1-2.122 2.122 1.5 1.5 0 0 1 2.122-2.122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.529 25.344a.464.464 0 0 1 0-.626l.987-1.064a1.783 1.783 0 0 0-1.7-2.953l-1.411.327a.454.454 0 0 1-.534-.312l-.423-1.391a1.776 1.776 0 0 0-3.4 0l-.424 1.391a.448.448 0 0 1-.533.312L21.68 20.7a1.783 1.783 0 0 0-1.7 2.953l.988 1.064a.464.464 0 0 1 0 .626l-.988 1.065a1.783 1.783 0 0 0 1.7 2.953l1.412-.327a.452.452 0 0 1 .532.31l.424 1.393a1.776 1.776 0 0 0 3.4 0l.423-1.393a.45.45 0 0 1 .534-.31l1.411.327a1.783 1.783 0 0 0 1.7-2.953l-.987-1.064zm-4.781 2.687a3 3 0 1 1 3-3 3 3 0 0 1-3 3z"
  })))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "global-white",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.018 19.239a.5.5 0 0 0 .592-.341v-.011a3.275 3.275 0 0 1 6.268 0v.012a.5.5 0 0 0 .591.34 3.255 3.255 0 0 1 2.125.229.479.479 0 0 0 .24-.831L21.028 8.412a1.5 1.5 0 0 0-2.06 0L8.157 18.637a.5.5 0 0 0 .343.863h2a.5.5 0 0 1 .5.5v10a1 1 0 0 0 1 1h5.984a.5.5 0 0 0 .5-.515l-.032-1.089a.513.513 0 0 0-.059-.221 3.272 3.272 0 0 1 .488-3.786l.0.017a.5.5 0 0 0 0-.68l-.0.017a3.282 3.282 0 0 1 3.138-5.434l-.001-.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.809 23.97a1.5 1.5 0 1 1-2.122 2.122 1.5 1.5 0 0 1 2.122-2.122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.529 25.344a.464.464 0 0 1 0-.626l.987-1.064a1.783 1.783 0 0 0-1.7-2.953l-1.411.327a.454.454 0 0 1-.534-.312l-.423-1.391a1.776 1.776 0 0 0-3.4 0l-.424 1.391a.448.448 0 0 1-.533.312L21.68 20.7a1.783 1.783 0 0 0-1.7 2.953l.988 1.064a.464.464 0 0 1 0 .626l-.988 1.065a1.783 1.783 0 0 0 1.7 2.953l1.412-.327a.452.452 0 0 1 .532.31l.424 1.393a1.776 1.776 0 0 0 3.4 0l.423-1.393a.45.45 0 0 1 .534-.31l1.411.327a1.783 1.783 0 0 0 1.7-2.953l-.987-1.064zm-4.781 2.687a3 3 0 1 1 3-3 3 3 0 0 1-3 3z"
  })))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "privacy",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.038 29.26a7.628 7.628 0 0 1-2.663.476.75.75 0 1 0 0 1.5c.96 0 1.912-.15 2.826-.442a.249.249 0 0 0 .174-.238V29.5a.25.25 0 0 0-.337-.235v-.005zM25.125 17.267v.076a.251.251 0 0 0 .3.245c.31-.068.628-.101.946-.1h.03a.22.22 0 0 0 .22-.219 9.154 9.154 0 0 0-1.921-5.653.748.748 0 0 0-1.05-.139.739.739 0 0 0-.13 1.049 7.736 7.736 0 0 1 1.605 4.741zM14.361 29.129a7.74 7.74 0 0 1-4.736-7.143V20.1a.75.75 0 1 0-1.5 0v1.888a9.235 9.235 0 0 0 5.652 8.522.75.75 0 0 0 .584-1.381zM8.847 17.542h.042a.75.75 0 0 0 .748-.709 7.751 7.751 0 0 1 11.615-6.28A.75.75 0 0 0 22 9.254a9.252 9.252 0 0 0-13.861 7.498.75.75 0 0 0 .708.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.467 19.411a.251.251 0 0 0 .28-.091c.263-.361.582-.679.944-.941a.252.252 0 0 0 .1-.2v-.912a6.419 6.419 0 0 0-8.42-6.1.747.747 0 0 0-.48.95.756.756 0 0 0 .94.48 4.733 4.733 0 0 1 1.54-.25 4.93 4.93 0 0 1 4.929 4.92v1.906a.25.25 0 0 0 .167.238zM20.245 26.138a.249.249 0 0 0-.254.008 4.88 4.88 0 0 1-2.616.76 4.929 4.929 0 0 1-4.92-4.92v-4.719a4.95 4.95 0 0 1 1.25-3.281.746.746 0 1 0-1.11-1 6.4 6.4 0 0 0-1.64 4.281v4.719a6.427 6.427 0 0 0 6.42 6.42 6.279 6.279 0 0 0 2.864-.688.251.251 0 0 0 .136-.222v-1.139a.25.25 0 0 0-.13-.219z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375 13.676a3.585 3.585 0 0 0-3.575 3.591v1.409a.75.75 0 0 0 1.5 0v-1.409a2.08 2.08 0 0 1 4.16 0v4.719a2.08 2.08 0 0 1-4.16 0 .75.75 0 1 0-1.5 0 3.58 3.58 0 0 0 6.55 2 .253.253 0 0 0 .042-.127c.018-.422.18-.826.46-1.143a.233.233 0 0 0 .06-.127c.032-.198.048-.399.048-.6v-4.722a3.585 3.585 0 0 0-3.585-3.591z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 21.514v-2.833a.75.75 0 1 0-1.5 0v2.833a.75.75 0 0 0 1.5 0zM30.589 23.5a.25.25 0 0 1-.214-.248v-1.016a3.5 3.5 0 1 0-7 0v1.018a.25.25 0 0 1-.214.248 1.5 1.5 0 0 0-1.286 1.484v5.5a1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5-1.5v-5.5a1.5 1.5 0 0 0-1.286-1.486zm-3.714 5.734a1 1 0 1 1 1-1 1 1 0 0 1-1 1.002v-.002zm1.5-6a.249.249 0 0 1-.25.25h-2.5a.249.249 0 0 1-.25-.25v-1a1.5 1.5 0 0 1 3 0v1z"
  })))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "privacy-white",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.038 29.26a7.628 7.628 0 0 1-2.663.476.75.75 0 1 0 0 1.5c.96 0 1.912-.15 2.826-.442a.249.249 0 0 0 .174-.238V29.5a.25.25 0 0 0-.337-.235v-.005zM25.125 17.267v.076a.251.251 0 0 0 .3.245c.31-.068.628-.101.946-.1h.03a.22.22 0 0 0 .22-.219 9.154 9.154 0 0 0-1.921-5.653.748.748 0 0 0-1.05-.139.739.739 0 0 0-.13 1.049 7.736 7.736 0 0 1 1.605 4.741zM14.361 29.129a7.74 7.74 0 0 1-4.736-7.143V20.1a.75.75 0 1 0-1.5 0v1.888a9.235 9.235 0 0 0 5.652 8.522.75.75 0 0 0 .584-1.381zM8.847 17.542h.042a.75.75 0 0 0 .748-.709 7.751 7.751 0 0 1 11.615-6.28A.75.75 0 0 0 22 9.254a9.252 9.252 0 0 0-13.861 7.498.75.75 0 0 0 .708.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.467 19.411a.251.251 0 0 0 .28-.091c.263-.361.582-.679.944-.941a.252.252 0 0 0 .1-.2v-.912a6.419 6.419 0 0 0-8.42-6.1.747.747 0 0 0-.48.95.756.756 0 0 0 .94.48 4.733 4.733 0 0 1 1.54-.25 4.93 4.93 0 0 1 4.929 4.92v1.906a.25.25 0 0 0 .167.238zM20.245 26.138a.249.249 0 0 0-.254.008 4.88 4.88 0 0 1-2.616.76 4.929 4.929 0 0 1-4.92-4.92v-4.719a4.95 4.95 0 0 1 1.25-3.281.746.746 0 1 0-1.11-1 6.4 6.4 0 0 0-1.64 4.281v4.719a6.427 6.427 0 0 0 6.42 6.42 6.279 6.279 0 0 0 2.864-.688.251.251 0 0 0 .136-.222v-1.139a.25.25 0 0 0-.13-.219z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375 13.676a3.585 3.585 0 0 0-3.575 3.591v1.409a.75.75 0 0 0 1.5 0v-1.409a2.08 2.08 0 0 1 4.16 0v4.719a2.08 2.08 0 0 1-4.16 0 .75.75 0 1 0-1.5 0 3.58 3.58 0 0 0 6.55 2 .253.253 0 0 0 .042-.127c.018-.422.18-.826.46-1.143a.233.233 0 0 0 .06-.127c.032-.198.048-.399.048-.6v-4.722a3.585 3.585 0 0 0-3.585-3.591z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 21.514v-2.833a.75.75 0 1 0-1.5 0v2.833a.75.75 0 0 0 1.5 0zM30.589 23.5a.25.25 0 0 1-.214-.248v-1.016a3.5 3.5 0 1 0-7 0v1.018a.25.25 0 0 1-.214.248 1.5 1.5 0 0 0-1.286 1.484v5.5a1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5-1.5v-5.5a1.5 1.5 0 0 0-1.286-1.486zm-3.714 5.734a1 1 0 1 1 1-1 1 1 0 0 1-1 1.002v-.002zm1.5-6a.249.249 0 0 1-.25.25h-2.5a.249.249 0 0 1-.25-.25v-1a1.5 1.5 0 0 1 3 0v1z"
  })))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "roles",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 19.985a1 1 0 0 0-1 1 3.317 3.317 0 0 1-1.994 3.381 17.708 17.708 0 0 1-1.783-6.677c-.208-1.8-.372-3.222-1.423-3.879a2.568 2.568 0 0 0-2.3-.074l-.433.155c-1.357.787-1.309 1.461-2.553 2.621-.308.291-.653.54-1.026.74a.5.5 0 0 1-.468-.883 5.347 5.347 0 0 0 1.63-1.514.25.25 0 0 0-.138-.396c-.333-.082-.839-.271-2-.691a2.668 2.668 0 0 0-2.339.075c-1.2.716-1.458 2.341-1.808 4.59a25.865 25.865 0 0 1-1.451 5.907A3.352 3.352 0 0 1 10 20.985a1 1 0 1 0-2 0c0 2.954 1.742 5.156 4.223 5.464.213.062 15.342.062 15.555 0 2.48-.308 4.222-2.511 4.222-5.464a1 1 0 0 0-1-1zm-16.3 4.5a.5.5 0 0 1-.476-.655c.1-.314.2-.638.292-.975a.5.5 0 0 1 .484-.366h9.707a.5.5 0 0 1 .476.346c.106.328.222.65.349.965a.5.5 0 0 1-.464.686L14.7 24.485z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "validation-check",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#00C28F"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 7.5L7 11l5.25-6"
  })))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
    fill: "currentColor"
  })))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "validation-error",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#F33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 5l6 6M11 5l-6 6"
  })))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "open-sidebar",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.585 10.999l-2.292-2.292 1.414-1.414L21.414 12l-4.707 4.707-1.414-1.414 2.294-2.294H4v-2h13.585zM4 5.001h10v2H4v-2zM4 17h10v2H4v-2z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "expand-sidebar",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.585 10.999l-2.292-2.292 1.414-1.414L21.414 12l-4.707 4.707-1.414-1.414 2.294-2.294H4v-2h13.585zM4 5.001h10v2H4v-2zM4 17h10v2H4v-2z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "edit",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,5H4c-1.105,0-2,.895-2,2v13c0,1.105,.895,2,2,2h13c1.105,0,2-.895,2-2v-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,16l-4,1,1-4L18.707,2.293c.391-.391,1.024-.391,1.414,0l1.586,1.586c.391,.391,.391,1.024,0,1.414l-10.707,10.707Z"
  })))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "edit-stroke-uncolored",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 .5L15.5 3l-8 8L4 12l1-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.5v5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h5"
  })))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "breadcrumb",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7A8198",
    strokeLinecap: "round",
    d: "M7 4l3 5-3 5"
  })))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "three-dots",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M4.586 10.586a2 2 0 1 1 2.828 2.828 2 2 0 0 1-2.828-2.828zm6 0a2 2 0 1 1 2.828 2.828 2 2 0 0 1-2.828-2.828zm6 0a2 2 0 1 1 2.828 2.828 2 2 0 0 1-2.828-2.828z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "three-dots-vertical",
    viewBox: "0 0 4 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.6106,15.4386a2,2,0,0,1,2.7788-2.8772q.025.0242.0492.0492a2,2,0,0,1-2.828,2.828Zm0-6A2,2,0,0,1,3.3894,6.5614q.025.0241.0492.0492a2,2,0,0,1-2.828,2.828Zm0-6A2,2,0,0,1,3.39.5614q.0249.0242.0491.0492a2,2,0,0,1-2.828,2.828Z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "logo",
    viewBox: "0 0 24.1 28.45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3c84f0",
    d: "M3,16.45a3,3,0,0,1-1.5-5.6L19.6.4a3,3,0,1,1,3,5.2L4.5,16.05A3,3,0,0,1,3,16.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M3,28.45a3,3,0,0,1-1.5-5.6L19.6,12.4a3,3,0,1,1,3,5.2L4.5,28.05A3,3,0,0,1,3,28.45Z"
  }))))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "add",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5.5v14M.5 7.5h14"
  })))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "add-white",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5.5v14M.5 7.5h14"
  })))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "back",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D6DADC",
    fillRule: "evenodd",
    d: "M6 12l11-8v16z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "sessions",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M18 4v2h-2V4H8v2H6V4H2v4h20V4h-4zm0-2h6v22H0V2h6V0h2v2h8V0h2v2zM2 10v12h20V10H2z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "sessions-gray",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A8198",
    fillRule: "nonzero",
    d: "M18 4v2h-2V4H8v2H6V4H2v4h20V4h-4zm0-2h6v22H0V2h6V0h2v2h8V0h2v2zM2 10v12h20V10H2z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "sessions-white",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M18 4v2h-2V4H8v2H6V4H2v4h20V4h-4zm0-2h6v22H0V2h6V0h2v2h8V0h2v2zM2 10v12h20V10H2z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "sporters",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M4 24H2c0-5.523 4.477-10 10-10s10 4.477 10 10h-2a8 8 0 1 0-16 0zm8-12a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "settings",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M21 9a3 3 0 1 1 0 6h-.523c-.105.298-.225.59-.361.874l.37.369a3 3 0 1 1-4.243 4.242l-.37-.37a8.958 8.958 0 0 1-.873.362V21a3 3 0 1 1-6 0v-.523a8.948 8.948 0 0 1-.874-.361l-.369.37a3 3 0 1 1-4.242-4.243l.37-.37A8.958 8.958 0 0 1 3.522 15H3a3 3 0 1 1 0-6h.523c.105-.298.226-.59.361-.874l-.37-.369a3 3 0 1 1 4.243-4.242l.37.37c.284-.136.575-.257.873-.362V3a3 3 0 1 1 6 0v.523c.298.105.59.226.874.361l.369-.37a3 3 0 1 1 4.242 4.243l-.37.37c.136.284.257.575.362.873H21zm1 3a1 1 0 0 0-1-1h-2.037l-.193-.75a6.968 6.968 0 0 0-.745-1.8l-.394-.667 1.44-1.44a1 1 0 1 0-1.414-1.414l-1.44 1.44-.667-.394a6.968 6.968 0 0 0-1.8-.745L13 5.037V3a1 1 0 0 0-2 0v2.037l-.75.193a6.968 6.968 0 0 0-1.8.745l-.667.394-1.44-1.44a1 1 0 1 0-1.414 1.414l1.44 1.44-.394.667a6.968 6.968 0 0 0-.745 1.8l-.193.75H3a1 1 0 0 0 0 2h2.037l.193.75c.164.636.415 1.24.745 1.8l.394.667-1.44 1.44a1 1 0 1 0 1.414 1.414l1.44-1.44.668.394c.558.33 1.162.58 1.799.745l.75.193V21a1 1 0 0 0 2 0v-2.037l.75-.193a6.968 6.968 0 0 0 1.8-.745l.667-.394 1.44 1.44a1 1 0 1 0 1.414-1.414l-1.44-1.44.394-.668c.33-.558.58-1.162.745-1.799l.193-.75H21a1 1 0 0 0 1-1zm-10 4a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "settings-gray",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A8198",
    fillRule: "nonzero",
    d: "M21 9a3 3 0 1 1 0 6h-.523c-.105.298-.225.59-.361.874l.37.369a3 3 0 1 1-4.243 4.242l-.37-.37a8.958 8.958 0 0 1-.873.362V21a3 3 0 1 1-6 0v-.523a8.948 8.948 0 0 1-.874-.361l-.369.37a3 3 0 1 1-4.242-4.243l.37-.37A8.958 8.958 0 0 1 3.522 15H3a3 3 0 1 1 0-6h.523c.105-.298.226-.59.361-.874l-.37-.369a3 3 0 1 1 4.243-4.242l.37.37c.284-.136.575-.257.873-.362V3a3 3 0 1 1 6 0v.523c.298.105.59.226.874.361l.369-.37a3 3 0 1 1 4.242 4.243l-.37.37c.136.284.257.575.362.873H21zm1 3a1 1 0 0 0-1-1h-2.037l-.193-.75a6.968 6.968 0 0 0-.745-1.8l-.394-.667 1.44-1.44a1 1 0 1 0-1.414-1.414l-1.44 1.44-.667-.394a6.968 6.968 0 0 0-1.8-.745L13 5.037V3a1 1 0 0 0-2 0v2.037l-.75.193a6.968 6.968 0 0 0-1.8.745l-.667.394-1.44-1.44a1 1 0 1 0-1.414 1.414l1.44 1.44-.394.667a6.968 6.968 0 0 0-.745 1.8l-.193.75H3a1 1 0 0 0 0 2h2.037l.193.75c.164.636.415 1.24.745 1.8l.394.667-1.44 1.44a1 1 0 1 0 1.414 1.414l1.44-1.44.668.394c.558.33 1.162.58 1.799.745l.75.193V21a1 1 0 0 0 2 0v-2.037l.75-.193a6.968 6.968 0 0 0 1.8-.745l.667-.394 1.44 1.44a1 1 0 1 0 1.414-1.414l-1.44-1.44.394-.668c.33-.558.58-1.162.745-1.799l.193-.75H21a1 1 0 0 0 1-1zm-10 4a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "settings-white",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M21 9a3 3 0 1 1 0 6h-.523c-.105.298-.225.59-.361.874l.37.369a3 3 0 1 1-4.243 4.242l-.37-.37a8.958 8.958 0 0 1-.873.362V21a3 3 0 1 1-6 0v-.523a8.948 8.948 0 0 1-.874-.361l-.369.37a3 3 0 1 1-4.242-4.243l.37-.37A8.958 8.958 0 0 1 3.522 15H3a3 3 0 1 1 0-6h.523c.105-.298.226-.59.361-.874l-.37-.369a3 3 0 1 1 4.243-4.242l.37.37c.284-.136.575-.257.873-.362V3a3 3 0 1 1 6 0v.523c.298.105.59.226.874.361l.369-.37a3 3 0 1 1 4.242 4.243l-.37.37c.136.284.257.575.362.873H21zm1 3a1 1 0 0 0-1-1h-2.037l-.193-.75a6.968 6.968 0 0 0-.745-1.8l-.394-.667 1.44-1.44a1 1 0 1 0-1.414-1.414l-1.44 1.44-.667-.394a6.968 6.968 0 0 0-1.8-.745L13 5.037V3a1 1 0 0 0-2 0v2.037l-.75.193a6.968 6.968 0 0 0-1.8.745l-.667.394-1.44-1.44a1 1 0 1 0-1.414 1.414l1.44 1.44-.394.667a6.968 6.968 0 0 0-.745 1.8l-.193.75H3a1 1 0 0 0 0 2h2.037l.193.75c.164.636.415 1.24.745 1.8l.394.667-1.44 1.44a1 1 0 1 0 1.414 1.414l1.44-1.44.668.394c.558.33 1.162.58 1.799.745l.75.193V21a1 1 0 0 0 2 0v-2.037l.75-.193a6.968 6.968 0 0 0 1.8-.745l.667-.394 1.44 1.44a1 1 0 1 0 1.414-1.414l-1.44-1.44.394-.668c.33-.558.58-1.162.745-1.799l.193-.75H21a1 1 0 0 0 1-1zm-10 4a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "signout",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5h7M12.5 5.5l3 3-3 3M8.5 4.5v-4h-8v11l5 4v-10l-5-5"
  })))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "funnel",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3C84F0",
    fillRule: "evenodd",
    d: "M0 3h16v2H0V3zm3 4h10v2H3V7zm3 4h4v2H6v-2z"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "back-nav",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.5h10a4 4 0 0 1 4 4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.5l-5 5 5 5"
  })))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "group",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.44 17.549A1.492 1.492 0 0 0 30.28 17H18.42a.5.5 0 0 1-.491-.4l-.278-1.395A1.5 1.5 0 0 0 16.18 14H9.72a1.5 1.5 0 0 0-1.471 1.8l2.6 13A1.5 1.5 0 0 0 12.32 30h15.961a1.5 1.5 0 0 0 1.47-1.2l2-10a1.5 1.5 0 0 0-.311-1.251zM11.22 13a1 1 0 0 0 .98-.778.263.263 0 0 1 .243-.222H27.72a.5.5 0 0 1 .5.5V15a1 1 0 1 0 2 0v-3a2 2 0 0 0-2-2h-16a2 2 0 0 0-2 2 1 1 0 0 0 1 1z"
  })))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "group-new-icon",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 44h33.15L46 18H12.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 10H20.5l-3.889-6H3v32"
  })))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "new-tab",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 3H3v10h10v-3M7 9l6-6M13 7V3H9"
  })))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "dropdown-closed",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A8198",
    fillRule: "evenodd",
    d: "M5 8l5-4v8z"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "dropdown-open-white",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M8 11L4 6h8z"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "desc",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3c84f0",
    fillRule: "evenodd",
    d: "M8 11L4 6h8z"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "flat-list-grey",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16.5h15M4.5 6.5h15M4.5 11.5h15"
  })))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "flat-list-white",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16.5h15M4.5 6.5h15M4.5 11.5h15"
  })))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "hierarchy-list-grey",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.5h2M4.5 6.5h15M10.5 11.5h9M12.5 16.5h7M5.5 9.5v2h2M7.5 14.5v2h2"
  })))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "hierarchy-list-white",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.5h2M4.5 6.5h15M10.5 11.5h9M12.5 16.5h7M5.5 9.5v2h2M7.5 14.5v2h2"
  })))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "profile",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.318 9A5 5 0 0 0 1.5 13.5s2 2 6.5 2 6.5-2 6.5-2A5 5 0 0 0 11.681 9M11.5 4c0 1.933-1.567 4.5-3.5 4.5S4.5 5.933 4.5 4a3.5 3.5 0 0 1 7 0z"
  })))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "test",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M13 2v1h-2V2H8V0h8v2h-3zm-1 22C6.477 24 2 19.523 2 14S6.477 4 12 4s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-9h4v2h-6V9h2v4z"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "test-gray",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A8198",
    fillRule: "nonzero",
    d: "M13 2v1h-2V2H8V0h8v2h-3zm-1 22C6.477 24 2 19.523 2 14S6.477 4 12 4s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-9h4v2h-6V9h2v4z"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "test-white",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M13 2v1h-2V2H8V0h8v2h-3zm-1 22C6.477 24 2 19.523 2 14S6.477 4 12 4s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-9h4v2h-6V9h2v4z"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "play",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10 17l6-5-6-5z"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "search-grey",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.078 3.422a4 4 0 1 1-5.656 5.656 4 4 0 0 1 5.656-5.656M9.08 9.08l4.67 4.67"
  })))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    viewBox: "0 0 15 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.854,14.146 C15.0495088,14.3415088 15.0495088,14.6584912 14.854,14.854 C14.6584912,15.0495088 14.3415088,15.0495088 14.146,14.854 L10.729,11.436 C8.07678887,13.7083321 4.10296699,13.4786258 1.7302499,10.9158284 C-0.642467181,8.35303099 -0.565860594,4.37331281 1.90372611,1.90372611 C4.37331281,-0.565860594 8.35303099,-0.642467181 10.9158284,1.7302499 C13.4786258,4.10296699 13.7083321,8.07678887 11.436,10.729 L14.854,14.146 Z M6.5,1 C3.46243388,1 1,3.46243388 1,6.5 C1,9.53756612 3.46243388,12 6.5,12 C9.53756612,12 12,9.53756612 12,6.5 C12,3.46243388 9.53756612,1 6.5,1 Z",
    id: "Combined-Shape"
  }))))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "download-white",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.5l4.5 5 4.5-5h-3v-6h-3v6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.5v4a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-4"
  })))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "add-group",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 11,
    x2: 12,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 14,
    x2: 9,
    y2: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,22H3a2,2,0,0,1-2-2V2H9l3,4H23V20A2,2,0,0,1,21,22Z"
  })))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "add-user",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 5.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.126,15c-1.236-.639-2.639-1-4.127-1C5.029,14,1,18.029,1,23H15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 16,
    x2: 19,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 19,
    x2: 22,
    y2: 19
  })))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "browse",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.5v-2h-7l-1-2h-4v11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.5l3-8h11l-3 8z"
  })))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.5l-11 11M2.5 2.5l11 11"
  })))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "copy",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "8 19 2 19 2 1 17 1 17 6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 10,
    height: 13
  })))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "delete",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,9l-.867,12.142A2,2,0,0,1,17.138,23H6.862a2,2,0,0,1-1.995-1.858L4,9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 5,
    x2: 23,
    y2: 5
  }), /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M8,5V1h8V5"
  })))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "recalculate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.05191 2c-3.33916 0-6.05191 2.80538-6.05191 6.25004 0 3.44456 2.71275 6.24996 6.05191 6.24996 2.43949 0 4.62879-1.5007 5.57729-3.8198.127-.3105-.0139-.6694-.3192-.80311-.31-.13482-.6667.01431-.7953.32891-.7614 1.8615-2.5132 3.0623-4.46279 3.0623-2.66905 0-4.84436-2.2496-4.84436-5.01826 0-2.76876 2.17528-5.01833 4.84436-5.01833l.22779.00551c1.51229.0733 2.892.87305 3.7448 2.13879l.0245.03899-1.3606-.46365c-.3185-.10989-.662.06759-.76624.3911-.10321.31967.06452.66695.37994.7759l2.7241.93116c.1884.05643.3573.02829.488-.0463.1327-.0757.2386-.20167.2893-.38323l.6799-2.95011c.0771-.32631-.1182-.65899-.4421-.7408l-.0978-.01627c-.2918-.02386-.5637.17238-.6342.46949l-.2963 1.28871-.0623-.09273c-1.1254-1.60236-2.9385-2.57827-4.89879-2.57827z"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "download",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.5l4.5 5 4.5-5h-3v-6h-3v6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.5v4a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-4"
  })))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "dropdown-open",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 11L4 6h8z"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "finish",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5.5v15M3.5 2.5h11v8h-11M3.5 6.5h11M6.5 2.5v8M10.5 2.5v8"
  })))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "link",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.5a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h3"
  })))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-external-bold",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("line", {
    "data-cap": "butt",
    "data-color": "color-2",
    x1: 11,
    y1: 13,
    x2: 22,
    y2: 2,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-color": "color-2",
    points: "14 2 22 2 22 10",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,4H4A2,2,0,0,0,2,6V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V15",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-external",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("line", {
    "data-cap": "butt",
    "data-color": "color-2",
    x1: 11,
    y1: 13,
    x2: 22,
    y2: 2,
    fill: "none",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-color": "color-2",
    points: "14 2 22 2 22 10",
    fill: "none",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,4H4A2,2,0,0,0,2,6V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V15",
    fill: "none",
    stroke: "currentColor"
  })))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "move",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 1,
    x2: 11,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    "data-cap": "butt",
    x1: 1,
    y1: 12,
    x2: 22,
    y2: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17,17 22,12 17,7 "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 16,
    x2: 11,
    y2: 23
  })))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "results",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    transform: "translate(.5 -.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 8.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.5 8.5h2L6 5l3 7 1.5-3.5h2"
  })))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "benchmarks",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 2,
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11h6l3-5 4 10 3-5h6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    strokeLinecap: "square"
  })))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "target",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.182 4.818a4.5 4.5 0 1 1-6.364 6.364 4.5 4.5 0 0 1 6.364-6.364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53 7.47a.75.75 0 1 1-1.06 1.06.75.75 0 0 1 1.06-1.06"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M8 11v3M2 8h3M11 8h3M8 2v3"
  })))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "checkbox-yes",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#071649",
    transform: "translate(13 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: -0.5,
    y: -0.5,
    fill: "#FFF",
    strokeOpacity: 0.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 6.5L6 10l5.25-6"
  })))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "checkbox-no",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 4.5,
    y: 4.5,
    fill: "#FFF",
    fillRule: "evenodd",
    stroke: "#071649",
    strokeOpacity: 0.5,
    rx: 2
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "checkbox-no-neutral",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 4.5,
    y: 4.5,
    fillRule: "evenodd",
    strokeOpacity: 0.5,
    rx: 2
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    id: "checkbox-yes-blue",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 4,
    y: 4,
    fill: "#3C84F0",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 11.5l3 3.5 5.25-6"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "checkbox-some-blue",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.866667,3.9999997 H 6.1333331 A 2.1333334,2.1333334 0 0 0 3.9999997,6.1333331 V 17.866667 A 2.1333334,2.1333334 0 0 0 6.1333331,20 H 17.866667 A 2.1333334,2.1333334 0 0 0 20,17.866667 V 6.1333331 A 2.1333334,2.1333334 0 0 0 17.866667,3.9999997 Z M 16.4,12.533333 H 7.5999998 a 0.53333335,0.53333335 0 0 1 0,-1.066666 H 16.4 a 0.53333335,0.53333335 0 0 1 0,1.066666 z",
    style: {
      fill: "#3c84f0",
      strokeWidth: 1.06667
    },
    id: "path139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.4,11.466667 H 7.5999998 a 0.53333335,0.53333335 0 0 0 0,1.066666 H 16.4 a 0.53333335,0.53333335 0 0 0 0,-1.066666 z",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.06667
    },
    id: "path141"
  })), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    id: "checkbox-yes-white",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#071649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 4.5,
    y: 4.5,
    fill: "#FFF",
    strokeOpacity: 0.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 11.5l3 3.5 5.25-6"
  })))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    id: "no-white",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 14.5l-11 11M14.5 14.5l11 11"
  })))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    id: "organisations-white",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M31 21h-5.5a.5.5 0 0 1-.5-.5V19a5.01 5.01 0 0 0-3.636-4.811.5.5 0 0 1-.364-.481V13a.5.5 0 0 1 .5-.5h2.253A1.252 1.252 0 0 0 25 11.25v-2A1.252 1.252 0 0 0 23.753 8h-4a.75.75 0 0 0-.753.75v4.958a.5.5 0 0 1-.363.481A5.009 5.009 0 0 0 15 19v1.5a.5.5 0 0 1-.5.5H9c-.55.007-.993.45-1 1v9a1 1 0 0 0 1 1h9.5a.5.5 0 0 0 .5-.5V27a1 1 0 1 1 2 0v4.5a.5.5 0 0 0 .5.5H31a.989.989 0 0 0 1-1v-9a1 1 0 0 0-1-1zm-17.247 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1zm0-4a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1zM20 20.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm9.75 8.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1zm0-4a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1z"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    id: "users-white",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.516 25.014l-2.868-1.273a.252.252 0 0 1-.148-.229v-1.143c0-.067.026-.13.074-.177a3.308 3.308 0 0 0 .779-2.23.253.253 0 0 1 .088-.177c.367-.371.561-.879.538-1.4a1.575 1.575 0 0 0-.317-1.014.251.251 0 0 1-.034-.265c.254-.54.309-1.15.156-1.727-.354-1.444-2.227-1.979-3.747-1.859a5.552 5.552 0 0 0-1.985.2.249.249 0 0 0-.171.184c-.033.148-.069.29-.1.425a.247.247 0 0 0 .016.173c.22.469.33.98.323 1.498a3.275 3.275 0 0 1-.658 2.03.247.247 0 0 0-.05.115 5.447 5.447 0 0 1-.7 1.973.251.251 0 0 0-.034.156c.037.397.128.786.271 1.158a.248.248 0 0 0 .14.139l2.256.894a4.974 4.974 0 0 1 3.155 4.649V30c0 .074-.004.149-.012.223a.249.249 0 0 0 .249.277H31.5a.5.5 0 0 0 .5-.5v-2.7a2.5 2.5 0 0 0-1.484-2.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 27.114a3.483 3.483 0 0 0-2.211-3.255l-4.131-1.637a.249.249 0 0 1-.158-.232v-1.55c0-.082.04-.16.108-.206a3.467 3.467 0 0 0 1.373-2.744.251.251 0 0 1 .1-.181c.374-.328.574-.812.539-1.309a1.7 1.7 0 0 0-.412-1.2.251.251 0 0 1-.059-.249 6.205 6.205 0 0 0 .336-3.174C21.139 9.992 19.256 9.5 17.75 9.5c-1.292 0-2.86.362-3.5 1.34a.252.252 0 0 1-.206.114 1.413 1.413 0 0 0-1.069.433c-.713.769-.357 2.253-.1 3.161a.251.251 0 0 1-.065.244 1.2 1.2 0 0 0-.207.279c-.15.286-.227.606-.223.929-.035.497.165.98.539 1.309.058.043.094.11.1.181a3.467 3.467 0 0 0 1.373 2.744.253.253 0 0 1 .108.206v1.551a.249.249 0 0 1-.158.232l-4.136 1.647A3.482 3.482 0 0 0 8 27.122V30a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-2.886z"
  })))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    id: "yes-white",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 21l4 4 10-10"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    id: "alert",
    viewBox: "0 0 96 96"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 6,
    d: "M50.734 88.508a4 4 0 0 1-5.657 0L6.735 50.166a4 4 0 0 1 0-5.657L45.077 6.167a4 4 0 0 1 5.657 0l38.342 38.342a4 4 0 0 1 0 5.657L50.734 88.508zM48 55.44v-28"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 8,
    d: "M48 63.44h-.036"
  })))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    id: "alert-round",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3204",
    transform: "matrix(0.04285714,0,0,0.04272548,-2.9999998,1.2817644e-4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 350.04,516.27 c 65.227,0 124.26,-26.383 167.02,-69.215 42.832,-42.75 69.215,-101.79 69.215,-167.02 0,-65.309 -26.383,-124.34 -69.215,-167.1 C 474.31,70.185 415.27,43.72 350.04,43.72 c -65.309,0 -124.34,26.465 -167.1,69.215 -42.75,42.75 -69.215,101.79 -69.215,167.1 0,65.227 26.465,124.26 69.215,167.02 42.75,42.832 101.79,69.215 167.1,69.215 z M 548,477.997 c -50.648,50.648 -120.68,82 -197.96,82 -77.359,0 -147.39,-31.352 -198.04,-82 -50.65,-50.648 -82,-120.68 -82,-197.96 0,-77.359 31.352,-147.39 82,-198.04 50.648,-50.648 120.68,-82 198.04,-82 77.277,0 147.31,31.352 197.96,82 50.648,50.648 82,120.68 82,198.04 0,77.277 -31.352,147.31 -82,197.96 z M 347.6,426.126 c -12.051,0 -21.906,-9.8516 -21.906,-21.906 0,-12.051 9.8516,-21.824 21.906,-21.824 h 4.8867 c 12.051,0 21.824,9.7734 21.824,21.824 0,12.051 -9.7734,21.906 -21.824,21.906 z m 24.105,-94.215 c 0,12.051 -9.8516,21.824 -21.906,21.824 -12.051,0 -21.824,-9.7734 -21.824,-21.824 v -176.14 c 0,-12.051 9.7734,-21.906 21.824,-21.906 12.0506,0 21.906,9.8516 21.906,21.906 z"
  })))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    id: "warning-sign",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.641,18.485,14.732,1.643a3.093,3.093,0,0,0-5.464,0L.359,18.485A3.079,3.079,0,0,0,3.092,23H20.908a3.079,3.079,0,0,0,2.733-4.515ZM12,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,20Zm1-5H11l-.5-8h3Z",
    fill: "currentColor"
  })))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    id: "big-send",
    viewBox: "0 0 96 96"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 38a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.344 3.008L45.6 18.2a4 4 0 0 0 4.8 0L70.656 3M48 58v36M36 50v28M60 50v28M72 12l14.212-7.104A4 4 0 0 1 92 8.472v2.82a4 4 0 0 1-2.516 3.712L82 18l2.48 1.656a4 4 0 0 1 .984 5.728L83.2 28.4A4 4 0 0 1 80 30M24 12L9.788 4.896A4 4 0 0 0 4 8.472v2.82a4 4 0 0 0 2.516 3.712L14 18l-2.48 1.656a4 4 0 0 0-.984 5.728L12.8 28.4A4 4 0 0 0 16 30"
  })))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    id: "send",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.504 9.503L12.5 15.5l3-15-15 6 2.002 1.501"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63 11.848L4.5 15.5l.004-5.997L9 6.5"
  })))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    id: "spreadsheet",
    viewBox: "0 0 96 96"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.828 18A4 4 0 0 1 86 20.828V90a4 4 0 0 1-4 4H14a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h53.172A4 4 0 0 1 70 3.164L84.828 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 74.996c0 1.656-1.792 3-4 3H26c-2.208 0-4-1.344-4-3v-42c0-1.66 1.792-3 4-3h44c2.208 0 4 1.34 4 3v42zM22 54h52M22 42h52M22 66h52M38 30v48"
  })))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    id: "success",
    viewBox: "0 0 96 96"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 38L47.72 59.704a3.068 3.068 0 0 1-4.62.332l-9.768-9.772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8 4.484a6.66 6.66 0 0 1 10.4 0l6.18 7.692a6.66 6.66 0 0 0 5.916 2.448l9.808-1.068a6.668 6.668 0 0 1 7.336 7.348l-1.068 9.804a6.664 6.664 0 0 0 2.452 5.916l7.688 6.176a6.664 6.664 0 0 1 0 10.4l-7.688 6.18a6.656 6.656 0 0 0-2.452 5.912L82.44 75.1a6.66 6.66 0 0 1-7.344 7.344l-9.808-1.068a6.672 6.672 0 0 0-5.916 2.452l-6.172 7.68a6.66 6.66 0 0 1-10.4 0l-6.172-7.688a6.672 6.672 0 0 0-5.92.452l-9.808 1.068a6.66 6.66 0 0 1-7.344-7.344l1.068-9.808a6.656 6.656 0 0 0-2.452-5.912L4.488 53.2a6.664 6.664 0 0 1 0-10.4l7.688-6.176a6.664 6.664 0 0 0 2.452-5.916l-1.068-9.804a6.668 6.668 0 0 1 7.344-7.348l9.808 1.068a6.66 6.66 0 0 0 5.92.448L42.8 4.484z"
  })))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    id: "upload",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6 32.636h4.8S46 31.5 46 22.946c.004-5.34-4.267-9.673-9.54-9.677-.123 0-.247.002-.37.007C32.942 6.51 24.976 3.61 18.296 6.798c-4.428 2.113-7.362 6.51-7.648 11.46-3.876-.826-7.68 1.688-8.494 5.614-.102.49-.154.989-.154 1.49 0 7.384 7.652 7.268 7.652 7.268h5.726M24 21.491v22.286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 27.571l-6-6.078-6 6.078"
  })))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    id: "checkbox-active",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#3C84F0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 11.75L10.5 17l7.875-9"
  })))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    id: "checkbox-inactive",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#D6DADC"
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    id: "facebook",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A8198",
    fillRule: "nonzero",
    d: "M16.512 8.977h-2.845v-1.27c0-.598.3.737.674-.737h1.992V4.342l-2.886-.009c-2.618 0-3.114 1.959-3.114 3.214v1.429h-2v2.667h2v8h3.334v-8h2.567l.278-2.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4h16v16H4z"
  })))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    id: "hamburger",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#34373E",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2h24v2H0zM0 11h24v2H0zM0 20h24v2H0z"
  })))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    id: "linked-in",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A8198",
    fillRule: "nonzero",
    d: "M8.351 18.333H5.018V9.667h3.333v8.666zm-1.672-10h-.02C5.65 8.333 5 7.545 5 6.68c0-.886.672-1.608 1.698-1.608 1.027 0 1.659.746 1.68 1.632-.001.866-.653 1.63-1.7 1.63zm7.672 4c-.736 0-1.333.598-1.333 1.334v4.666H9.685s.039-8 0-8.666h3.333v.99s1.032-.962 2.625-.962c1.975 0 3.375 1.429 3.375 4.202v4.436h-3.333v-4.666c0-.736-.597-1.334-1.334-1.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4h16v16H4z"
  })))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    id: "my-profile-gray",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A8198",
    fillRule: "nonzero",
    d: "M19.586 8l-3-3L18 3.586 23.414 9 18 14.414 16.586 13l3-3H11V8h8.586zM9 15h3v-3h2v5H9v5.943l-9-6.428V0h14v6h-2V2H4.112L9 5.502V15zM2 2.947v12.538l5 3.572V6.53L2 2.947z"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    id: "sets",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 9.25a1 1 0 0 0 1 1h3.4a.74.74 0 0 1 .668.426 2.752 2.752 0 0 0 2.48 1.574H27a1 1 0 1 0 0-2h-6.456a.741.741 0 0 1-.669-.426A2.753 2.753 0 0 0 17.4 8.25H14a1 1 0 0 0-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22a.5.5 0 0 0 .5-.5v-7.482a.5.5 0 0 1 .5-.5h2.9c.286 0 .546.166.668.425a2.755 2.755 0 0 0 2.48 1.575H27a.5.5 0 0 1 .5.5V21.5a.5.5 0 0 0 .5.5h2.95a.5.5 0 0 0 .49-.6l-.45-2.25a.5.5 0 0 0-.49-.4h-.75a.25.25 0 0 1-.25-.25v-3.982a1 1 0 0 0-1-1h-9.456a.741.741 0 0 1-.669-.426 2.753 2.753 0 0 0-2.475-1.574h-4.4a1 1 0 0 0-1 1V18.5a.25.25 0 0 1-.25.25H9.5a.5.5 0 0 0-.49.4l-.446 2.25a.5.5 0 0 0 .49.6H12zM26.5 23a2.5 2.5 0 0 0-2.5 2.5.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5 2.5 2.5 0 0 0-2.5-2.5h-5a.5.5 0 0 0-.5.5v7.75a.5.5 0 0 0 .5.5h23a.5.5 0 0 0 .5-.5l-.009-7.75a.5.5 0 0 0-.5-.5H26.5z"
  })))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    id: "twitter",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A8198",
    fillRule: "nonzero",
    d: "M19.63 7.223c-.543.242-1 .25-1.485.01.625-.374.654-.638.88-1.346-.586.348-1.234.6-1.924.736a3.03 3.03 0 0 0-5.162 2.763 8.598 8.598 0 0 1-6.244-3.165 3.03 3.03 0 0 0 .937 4.045 3.018 3.018 0 0 1-1.371-.379l-.001.038a3.031 3.031 0 0 0 2.43 2.971 3.05 3.05 0 0 1-1.368.053 3.034 3.034 0 0 0 2.83 2.103 6.092 6.092 0 0 1-4.485 1.254 8.577 8.577 0 0 0 4.644 1.36c5.572 0 8.618-4.615 8.618-8.619 0-.132-.002-.262-.008-.392.592-.426 1.302-.824 1.708-1.432z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4h16v16H4z"
  })))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    id: "upload-gray",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23V10"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M9 13l3-3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M16 18h3a4 4 0 0 0 4-4 3.995 3.995 0 0 0-4.025-3.997C18.718 6.093 15.474 3 11.5 3c-4.019 0-7.29 3.164-7.482 7.136A3.992 3.992 0 0 0 1 14a4 4 0 0 0 4 4h3"
  })))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    id: "database-error",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#7A8198",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M0 0h22v8H0zM12.055 20H0v-8h22M8 4H4M8 16H4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 4,
    r: 1,
    fill: "#7A8198",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#F33",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.121 17.879L16.88 22.12M16.879 17.879l4.242 4.242"
  }))))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    id: "retry",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#3C84F0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5c1.9-1.9 5.1-1.9 7 0 .7.7 1.2 1.7 1.4 2.7l2-.3c-.2-1.5-.9-2.8-1.9-3.8C10.3.4 5.9.4 3.1 3.1L.9.9.2 7.3l6.4-.7-2.1-2.1zM15.8 8.7l-6.4.7 2.1 2.1c-1.9 1.9-5.1 1.9-7 0-.7-.7-1.2-1.7-1.4-2.7l-2 .3c.2 1.5.9 2.8 1.9 3.8 1.4 1.4 3.1 2 4.9 2 1.8 0 3.6-.7 4.9-2l2.2 2.2.8-6.4z"
  })))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    id: "scanner",
    viewBox: "0 0 78 92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.4,10.9 C68.4,3.4 58,-0.2 47,0.6 C27.8,2 12.4,17.7 11.1,37.1 C10.6,44.3 12.1,51.5 15.3,57.8 C16,59.1 16.3,60.5 16.3,61.9 L16.3,73.1 C16.3,79.2 21.2,84.1 27.2,84.1 L40,84.1 L40.3,86.8 C40.6,89.5 42.9,91.5 45.6,91.5 L54.1,91.5 C56.8,91.5 59.1,89.5 59.4,86.8 L59.7,84.1 L72.5,84.1 C78.5,84.1 83.4,79.2 83.4,73.1 L83.4,61.9 C83.4,60.5 83.7,59.1 84.4,57.8 C87.3,52.2 88.7,46.2 88.7,39.8 C89,28.9 84.4,18.3 76.4,10.9 Z M47.3,3.6 C57.4,2.8 67,6.2 74.4,13.1 C80.3,18.6 84.2,25.8 85.5,33.7 L68,33.7 C65.8,25.8 58.6,19.9 50,19.9 C41.4,19.9 34.2,25.7 32,33.7 L14.5,33.7 C17.3,17.5 30.8,4.8 47.3,3.6 Z M57.6,52.6 C57.6,52.6 57.6,52.6 57.6,52.6 C57.1,52.5 56.6,52.4 56.1,52.4 L43.9,52.4 C43.4,52.4 42.9,52.5 42.4,52.6 C42.4,52.6 42.4,52.6 42.3,52.6 C39.6,51.1 37.5,48.9 36.1,46.3 L42.4,42.6 C44.5,44.2 47.1,45.2 49.9,45.2 C52.6,45.2 55.1,44.3 57.2,42.8 L63.7,46.4 C62.4,48.9 60.3,51.1 57.6,52.6 Z M57.8,56.5 L62.2,66.6 L37.8,66.6 L42.2,56.5 C42.5,55.8 43.2,55.4 43.9,55.4 L56.1,55.4 C56.8,55.4 57.5,55.8 57.8,56.5 Z M38,36.1 C38.5,37.7 39.2,39.1 40.2,40.4 L35,43.5 C34.5,42 34.3,40.4 34.3,38.8 C34.3,38.2 34.4,37.5 34.4,36.9 L38,36.1 Z M35.2,33.6 C35.9,31.6 36.9,29.8 38.3,28.3 C37.8,29.6 37.6,32.9 37.6,33.1 L35.2,33.6 Z M40.5,32.5 C40.5,27.2 44.8,22.9 50,22.9 C55.2,22.9 59.5,27.2 59.5,32.5 C59.5,37.8 55.2,42.1 50,42.1 C44.8,42.1 40.5,37.8 40.5,32.5 Z M59.6,40.6 C60.7,39.3 61.5,37.7 62,36.1 L65.5,36.8 C65.6,37.5 65.7,38.2 65.7,38.9 C65.7,40.5 65.4,42.2 65,43.7 L59.6,40.6 Z M61.7,28.3 C63,29.8 64.1,31.6 64.7,33.5 L62.5,33 C62.5,32.9 62.2,29.6 61.7,28.3 Z M14.1,37.3 C14.1,37.1 14.1,36.9 14.2,36.7 L31.5,36.7 C31.4,37.4 31.4,38.1 31.4,38.8 C31.4,40.7 31.7,42.5 32.2,44.2 L14.3,44.2 C14,41.9 13.9,39.6 14.1,37.3 Z M27.3,81.1 C22.9,81.1 19.4,77.5 19.4,73.1 L19.4,61.9 C19.4,60 18.9,58.2 18.1,56.4 C16.6,53.5 15.5,50.4 14.9,47.1 L33.4,47.1 C34.9,50.1 37.1,52.6 40,54.5 C39.8,54.7 39.7,55 39.6,55.3 L33.4,69.4 C33.4,69.4 33.4,69.4 33.4,69.5 C33.1,70.1 32.9,70.8 32.9,71.6 L32.9,74.7 C32.9,77.5 35.2,79.7 37.9,79.7 L39.7,79.7 L39.9,81.1 L27.3,81.1 Z M56.6,86.4 C56.5,87.6 55.5,88.5 54.3,88.5 L45.8,88.5 C44.6,88.5 43.6,87.6 43.5,86.4 L42.7,79.7 L57.6,79.7 L56.6,86.4 Z M59.1,76.7 L40.9,76.7 L37.8,76.7 C36.7,76.7 35.8,75.8 35.8,74.7 L35.8,71.6 C35.8,70.5 36.7,69.6 37.8,69.6 L62.3,69.6 C63.4,69.6 64.3,70.5 64.3,71.6 L64.3,74.7 C64.3,75.8 63.4,76.7 62.3,76.7 L59.1,76.7 Z M82,56.4 C81.1,58.2 80.6,60.1 80.6,61.9 L80.6,73.1 C80.6,77.5 77,81.1 72.7,81.1 L60.3,81.1 L60.5,79.7 L62.3,79.7 C65.1,79.7 67.3,77.4 67.3,74.7 L67.3,71.6 C67.3,70.8 67.1,70.1 66.8,69.5 C66.8,69.5 66.8,69.5 66.8,69.5 L60.6,55.4 C60.5,55.1 60.3,54.9 60.2,54.6 C63,52.8 65.3,50.2 66.8,47.2 L85.3,47.2 C84.6,50.4 83.5,53.5 82,56.4 Z M67.9,44.2 C68.4,42.5 68.7,40.6 68.7,38.8 C68.7,38.1 68.7,37.4 68.6,36.7 L85.9,36.7 C86,37.7 86,38.8 86,39.8 C86,41.3 85.9,42.7 85.7,44.2 L67.9,44.2 Z",
    transform: "translate(-11)"
  }))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    id: "calibrate",
    viewBox: "0 0 32.04 29.81"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.14,8.22A1.14,1.14,0,0,1,0,7.08v-6A1.13,1.13,0,0,1,1.14,0H7A1.13,1.13,0,0,1,7,2.25H2.26V7.08A1.14,1.14,0,0,1,1.14,8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.92,8.22a1.13,1.13,0,0,1-1.13-1.14V2.25H25a1.13,1.13,0,0,1-1.24-1,1.14,1.14,0,0,1,1-1.24h6.1A1.14,1.14,0,0,1,32,1.12v6A1.15,1.15,0,0,1,30.92,8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,29.8H1.14A1.12,1.12,0,0,1,0,28.68v-7a1.13,1.13,0,0,1,1-1.24,1.14,1.14,0,0,1,1.24,1v6.09H7a1.11,1.11,0,0,1,1,1.23,1.13,1.13,0,0,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.92,29.8H25a1.13,1.13,0,0,1-1.24-1,1.14,1.14,0,0,1,1-1.24h5V21.69a1.13,1.13,0,0,1,1-1.24,1.14,1.14,0,0,1,1.24,1v7.22A1.13,1.13,0,0,1,30.92,29.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.69,13.87H11.35c-.17,0-.3-.52-.28-1.06s.13-.82.28-.87h9.34c.17.05.3.52.28,1.06S20.84,13.82,20.69,13.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,7.94v9.93c-.05.19-.52.32-1.05.3s-.83-.14-.87-.3V7.94c0-.19.52-.32,1-.3S16.94,7.78,17,7.94Z"
  })))))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    id: "language",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.727 3.615l6.864 11.889M15.81 6.331c-2.784 2.493-6.164-.561-8.232 3.083L4.327 3.783C6.394.138 9.8 3.232 12.558.7l3.252 5.631z"
  })))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    id: "packs",
    viewBox: "0 0 24 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "packs-gray",
    transform: "translate(1.000000, 1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,1 L1,4 L21,4 L21,1 L1,1 Z M23,-1 L23,6 L-1,6 L-1,-1 L23,-1 Z M19,10 L3,10 L3,19 L19,19 L19,10 Z M21,21 L1,21 L1,8 L21,8 L21,21 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,10 L9,12 L13,12 L13,10 L9,10 Z M15,8 L15,14 L7,14 L7,8 L15,8 Z",
    id: "Path"
  }))))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    id: "graph",
    viewBox: "0 0 24 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph-white",
    transform: "translate(2.000000, 2.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.37106056,5.49394686 L4.4472136,11.3416408 L2.65835921,10.4472136 L6.62893944,2.50605314 L13.740832,7.58597638 L19.7226499,-1.38675049 L21.3867505,-0.277350098 L14.259168,10.4140236 L7.37106056,5.49394686 Z M0.447213595,19.3416408 L-1.34164079,18.4472136 L1.7987864,12.1663592 L3.58764079,13.0607864 L0.447213595,19.3416408 Z M-1,11 L-1,9 L4.23606798,9 L13.9281573,13.8460447 L20.2773501,9.61324951 L21.3867505,11.2773501 L14.0718427,16.1539553 L3.76393202,11 L-1,11 Z",
    id: "Shape"
  }))))), _symbol102 || (_symbol102 = /*#__PURE__*/React.createElement("symbol", {
    id: "graph-bar",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 16v4H5v-4zM15 10v4H5v-4zM11 4v4H5V4z"
  })))), _symbol103 || (_symbol103 = /*#__PURE__*/React.createElement("symbol", {
    id: "eye-enabled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 2,
    transform: "translate(1 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 6s-4.924 6-11 6S0 6 0 6s4.924-6 11-6 11 6 11 6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 6,
    r: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _symbol104 || (_symbol104 = /*#__PURE__*/React.createElement("symbol", {
    id: "eye-disabled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9s4-7 10-7 10 7 10 7-4 7-10 7S0 9 0 9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 18L19 0"
  })))), _symbol105 || (_symbol105 = /*#__PURE__*/React.createElement("symbol", {
    id: "sort",
    viewBox: "0 0 17 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1580383,10.4792231 C16.359499,10.2903629 16.6759166,10.3005776 16.8647769,10.5020383 C17.0536371,10.703499 17.0434224,11.0199166 16.8419617,11.2087769 L11.3419617,16.3647769 C11.0226257,16.6641399 10.5,16.4377142 10.5,16 L10.5,1 C10.5,0.723857625 10.7238576,0.5 11,0.5 C11.2761424,0.5 11.5,0.723857625 11.5,1 L11.5,14.8459223 L16.1580383,10.4792231 Z M1.34196174,7.52077688 C1.14050103,7.70963713 0.824083379,7.69942244 0.635223125,7.49796174 C0.446362871,7.29650103 0.456577555,6.98008338 0.65803826,6.79122312 L6.15803826,1.63522312 C6.47737426,1.33586014 7,1.56228585 7,2 L7,17 C7,17.2761424 6.77614237,17.5 6.5,17.5 C6.22385763,17.5 6,17.2761424 6,17 L6,3.15407774 L1.34196174,7.52077688 Z",
    id: "Shape",
    fill: "#7A8198",
    fillRule: "nonzero"
  })))), _symbol106 || (_symbol106 = /*#__PURE__*/React.createElement("symbol", {
    id: "sort-down",
    viewBox: "0 0 17 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sort",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1580383,10.4792231 C16.359499,10.2903629 16.6759166,10.3005776 16.8647769,10.5020383 C17.0536371,10.703499 17.0434224,11.0199166 16.8419617,11.2087769 L11.3419617,16.3647769 C11.0226257,16.6641399 10.5,16.4377142 10.5,16 L10.5,1 C10.5,0.723857625 10.7238576,0.5 11,0.5 C11.2761424,0.5 11.5,0.723857625 11.5,1 L11.5,14.8459223 L16.1580383,10.4792231 Z",
    id: "Shape-path",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34196174,7.52077688 C1.14050103,7.70963713 0.824083379,7.69942244 0.635223125,7.49796174 C0.446362871,7.29650103 0.456577555,6.98008338 0.65803826,6.79122312 L6.15803826,1.63522312 C6.47737426,1.33586014 7,1.56228585 7,2 L7,17 C7,17.2761424 6.77614237,17.5 6.5,17.5 C6.22385763,17.5 6,17.2761424 6,17 L6,3.15407774 L1.34196174,7.52077688 Z",
    id: "Shape-path",
    fill: "#7A8198",
    opacity: 0.5
  }))))), _symbol107 || (_symbol107 = /*#__PURE__*/React.createElement("symbol", {
    id: "sort-up",
    viewBox: "0 0 17 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sort",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1580383,10.4792231 C16.359499,10.2903629 16.6759166,10.3005776 16.8647769,10.5020383 C17.0536371,10.703499 17.0434224,11.0199166 16.8419617,11.2087769 L11.3419617,16.3647769 C11.0226257,16.6641399 10.5,16.4377142 10.5,16 L10.5,1 C10.5,0.723857625 10.7238576,0.5 11,0.5 C11.2761424,0.5 11.5,0.723857625 11.5,1 L11.5,14.8459223 L16.1580383,10.4792231 Z",
    id: "Shape-path",
    fill: "#7A8198",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34196174,7.52077688 C1.14050103,7.70963713 0.824083379,7.69942244 0.635223125,7.49796174 C0.446362871,7.29650103 0.456577555,6.98008338 0.65803826,6.79122312 L6.15803826,1.63522312 C6.47737426,1.33586014 7,1.56228585 7,2 L7,17 C7,17.2761424 6.77614237,17.5 6.5,17.5 C6.22385763,17.5 6,17.2761424 6,17 L6,3.15407774 L1.34196174,7.52077688 Z",
    id: "Shape-path",
    fill: "#3C84F0"
  }))))), _symbol108 || (_symbol108 = /*#__PURE__*/React.createElement("symbol", {
    id: "calendar",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 5.5h15M14.5 2.5h-13a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1zM4.5.5v2M11.5.5v2"
  })))), _symbol109 || (_symbol109 = /*#__PURE__*/React.createElement("symbol", {
    id: "bookmark",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2,15.3L8,12.4l5.8,2.9V2.7c0-1.1-0.9-1.9-1.9-1.9H4.1C3,0.7,2.2,1.6,2.2,2.7V15.3z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol110 || (_symbol110 = /*#__PURE__*/React.createElement("symbol", {
    id: "bookmark-outline",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2,15.3L8,12.4l5.8,2.9V2.7c0-1.1-0.9-1.9-1.9-1.9H4.1C3,0.7,2.2,1.6,2.2,2.7V15.3z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol111 || (_symbol111 = /*#__PURE__*/React.createElement("symbol", {
    id: "question",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#7A8198",
    fillRule: "evenodd",
    transform: "translate(7 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.29 10.871c0-.807-.051-1.727.418-2.584.28-.51.767-1.036 1.465-1.58C6.553 5.617 7.14 5.05 7.14 3.882c0-1.297-.969-1.82-2.27-1.82-.858 0-1.81.13-3.496.962L.496 1.183A9.206 9.206 0 0 1 5.047 0C6.414 0 7.5.335 8.301 1.004c.803.67 1.204 1.594 1.204 2.773 0 .983-.264 1.774-.926 2.564-.311.37-.846.85-1.606 1.443-.649.51-1.084.932-1.302 1.266-.361.549-.33 1.175-.33 1.82H3.289v.001z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.286,
    cy: 14.286,
    r: 1.429
  })))), _symbol112 || (_symbol112 = /*#__PURE__*/React.createElement("symbol", {
    id: "print",
    viewBox: "0 0 106 104"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A8198",
    stroke: "#7A8198",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M14.911,104.5 L93.124,104.5 L93.124,78.743 L106.241,78.743 L106.241,27.68 L93.106,27.68 L93.106,1.5 L14.894,1.5 L14.894,27.68 L1.759,27.68 L1.759,78.743 L14.911,78.743 L14.911,104.5 Z M90.124,101.5 L17.911,101.5 L17.911,54.711 L90.124,54.711 L90.124,101.5 Z M17.894,4.5 L90.107,4.5 L90.107,27.68 L17.894,27.68 L17.894,4.5 Z M4.759,75.743 L4.759,30.68 L14.894,30.68 L93.107,30.68 L103.242,30.68 L103.242,75.743 L93.124,75.743 L93.124,51.711 L14.911,51.711 L14.911,75.743 L4.759,75.743 Z M81.29,68.255 L26.745,68.255 L26.745,65.255 L81.29,65.255 L81.29,68.255 Z M81.29,80.606 L26.745,80.606 L26.745,77.606 L81.29,77.606 L81.29,80.606 Z M81.29,92.956 L26.745,92.956 L26.745,89.956 L81.29,89.956 L81.29,92.956 Z"
  }))), _symbol113 || (_symbol113 = /*#__PURE__*/React.createElement("symbol", {
    id: "print-white",
    viewBox: "0 0 106 104"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M14.911,104.5 L93.124,104.5 L93.124,78.743 L106.241,78.743 L106.241,27.68 L93.106,27.68 L93.106,1.5 L14.894,1.5 L14.894,27.68 L1.759,27.68 L1.759,78.743 L14.911,78.743 L14.911,104.5 Z M90.124,101.5 L17.911,101.5 L17.911,54.711 L90.124,54.711 L90.124,101.5 Z M17.894,4.5 L90.107,4.5 L90.107,27.68 L17.894,27.68 L17.894,4.5 Z M4.759,75.743 L4.759,30.68 L14.894,30.68 L93.107,30.68 L103.242,30.68 L103.242,75.743 L93.124,75.743 L93.124,51.711 L14.911,51.711 L14.911,75.743 L4.759,75.743 Z M81.29,68.255 L26.745,68.255 L26.745,65.255 L81.29,65.255 L81.29,68.255 Z M81.29,80.606 L26.745,80.606 L26.745,77.606 L81.29,77.606 L81.29,80.606 Z M81.29,92.956 L26.745,92.956 L26.745,89.956 L81.29,89.956 L81.29,92.956 Z"
  }))), _symbol114 || (_symbol114 = /*#__PURE__*/React.createElement("symbol", {
    id: "print-primary",
    viewBox: "0 0 106 104"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3C84F0",
    stroke: "#3C84F0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M14.911,104.5 L93.124,104.5 L93.124,78.743 L106.241,78.743 L106.241,27.68 L93.106,27.68 L93.106,1.5 L14.894,1.5 L14.894,27.68 L1.759,27.68 L1.759,78.743 L14.911,78.743 L14.911,104.5 Z M90.124,101.5 L17.911,101.5 L17.911,54.711 L90.124,54.711 L90.124,101.5 Z M17.894,4.5 L90.107,4.5 L90.107,27.68 L17.894,27.68 L17.894,4.5 Z M4.759,75.743 L4.759,30.68 L14.894,30.68 L93.107,30.68 L103.242,30.68 L103.242,75.743 L93.124,75.743 L93.124,51.711 L14.911,51.711 L14.911,75.743 L4.759,75.743 Z M81.29,68.255 L26.745,68.255 L26.745,65.255 L81.29,65.255 L81.29,68.255 Z M81.29,80.606 L26.745,80.606 L26.745,77.606 L81.29,77.606 L81.29,80.606 Z M81.29,92.956 L26.745,92.956 L26.745,89.956 L81.29,89.956 L81.29,92.956 Z"
  }))), _symbol115 || (_symbol115 = /*#__PURE__*/React.createElement("symbol", {
    id: "folder",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5,1 A 0.50005,0.50005 0 0 0 0,1.5 v 11 C 0,13.874788 1.1252118,15 2.5,15 h 11 c 1.374788,0 2.5,-1.125212 2.5,-2.5 v -8 A 0.50005,0.50005 0 0 0 15.5,4 H 7.7675781 L 5.9160156,1.2226562 A 0.50005,0.50005 0 0 0 5.5,1 Z M 1,2 H 5.2324219 L 7.0839844,4.7773437 A 0.50005,0.50005 0 0 0 7.5,5 H 15 v 7.5 C 15,13.334349 14.334349,14 13.5,14 H 2.5 C 1.6656514,14 1,13.334349 1,12.5 Z",
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol116 || (_symbol116 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 68.0008 59.0011",
    id: "growth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.4986 59.0011a2.4883 2.4883 0 0 1 -1.3584-.4023l-9.3652-6.0752a2.5037 2.5037 0 0 1 -.9727-1.1983l-7.6767-19.9218-10.0772 14.3818a2.5025 2.5025 0 0 1 -2.832.94l-20.4326-6.75a2.4994 2.4994 0 0 1 -1.6-1.6221l-11.0675-35.1001a2.5 2.5 0 0 1 4.7686-1.5039l10.6826 33.8789 17.4525 5.7656 11.7032-16.7021a2.5006 2.5006 0 0 1 4.3809.5356l9.0723 23.5428 8.6845 5.6338a2.5 2.5 0 0 1 -1.3623 4.5976z"
  }))), _symbol117 || (_symbol117 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 32 32",
    id: "exercise"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 25,1 c -2.197292,0 -4,1.8027078 -4,4 0,2.1972922 1.802708,4 4,4 2.197292,0 4,-1.8027078 4,-4 0,-2.1972922 -1.802708,-4 -4,-4 z m 0,2 c 1.116413,0 2,0.883587 2,2 0,1.116413 -0.883587,2 -2,2 -1.116413,0 -2,-0.883587 -2,-2 0,-1.116413 0.883587,-2 2,-2 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.511719,5.171875 C 9.7819311,5.1812305 9.0911943,5.5912027 8.75,6.2636719 a 1.0001,1.0001 0 0 0 -0.00391,0.00586 L 7.1054688,9.5527344 A 1,1 0 0 0 7.5527344,10.894531 1,1 0 0 0 8.8945312,10.447266 L 10.533203,7.1699219 a 1.0001,1.0001 0 0 0 0.0039,0 l 5.617188,1.4003906 -5.083985,5.7207035 c -1.3299629,1.496366 -0.80572,3.920681 1.023438,4.734375 l 5.380859,2.388671 a 1.0001,1.0001 0 0 0 0.002,0.002 1.0001,1.0001 0 0 0 -0.002,0.002 l -4.289062,6 a 1,1 0 0 0 0.232422,1.396484 1,1 0 0 0 1.396484,-0.232422 l 4.285156,-5.998047 C 19.830288,21.5707 19.427279,20.091245 18.28515,19.586031 l -5.3789,-2.388765 c -0.644324,-0.286625 -0.808325,-1.051028 -0.339844,-1.578125 h -0.002 L 18.117188,9.375 21.59375,12.15625 18.21875,16.375 A 1,1 0 0 0 18.375,17.78125 1,1 0 0 0 19.78125,17.625 l 3.023438,-3.779297 1.853515,3.707031 c 0.48883,0.976492 1.704682,1.382427 2.681641,0.894532 a 1.0001,1.0001 0 0 0 0.002,0 l 3.105469,-1.552735 a 1,1 0 0 0 0.447265,-1.341797 1,1 0 0 0 -1.341797,-0.447265 l -3.105468,1.552734 -2.550782,-5.101562 A 1,1 0 0 0 23.625,11.21875 l -5,-4 A 1.0001,1.0001 0 0 0 18.513672,7.1640625 1,1 0 0 0 18.28125,7.0488281 1.0001,1.0001 0 0 0 18.242188,7.0292969 l -7.21875,-1.7988281 h -0.0039 c -0.168732,-0.042309 -0.3394,-0.060753 -0.507812,-0.058594 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.9335938,20.001953 a 1,1 0 0 0 -0.6855469,0.339844 l -7,8 a 1,1 0 0 0 0.09375,1.410156 1,1 0 0 0 1.4101562,-0.09375 l 6.9999999,-8 a 1,1 0 0 0 -0.09375,-1.410156 1,1 0 0 0 -0.7246092,-0.246094 z"
  }))), _symbol118 || (_symbol118 = /*#__PURE__*/React.createElement("symbol", {
    id: "use-template",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "13 19 13 15 17 15 13 19",
    stroke: "none",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    points: "13 19 13 15 17 15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1,
    width: 18,
    height: 22
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13 19 7 19 7 5 17 5 17 15 13 19"
  })))), _symbol119 || (_symbol119 = /*#__PURE__*/React.createElement("symbol", {
    id: "program",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6,0.5 C 5.177555,0.5000822 4.5000822,1.177555 4.5,2 v 44 c 8.22e-5,0.822445 0.677555,1.499918 1.5,1.5 h 36 c 0.822445,-8.2e-5 1.499918,-0.677555 1.5,-1.5 V 14 c 0,-0.100069 -0.0102,-0.198152 -0.0293,-0.292969 -5.26e-4,-0.0026 -0.0014,-0.0052 -0.002,-0.0078 -0.01954,-0.09438 -0.04741,-0.186234 -0.08398,-0.273438 -8.97e-4,-0.0022 -0.003,-0.0057 -0.0039,-0.0078 -0.03146,-0.07383 -0.06889,-0.143596 -0.111328,-0.210938 -0.01691,-0.02708 -0.03603,-0.0521 -0.05469,-0.07813 -0.03695,-0.05117 -0.07622,-0.100362 -0.119141,-0.146484 -0.01266,-0.01363 -0.02195,-0.02977 -0.03516,-0.04297 l -12,-11.9999999 c -0.0132,-0.013202 -0.02933,-0.0225 -0.04297,-0.035156 -0.04612,-0.042917 -0.09532,-0.082192 -0.146484,-0.1191407 -0.02602,-0.01866 -0.05104,-0.037778 -0.07813,-0.054687 -0.06734,-0.042435 -0.139065,-0.079863 -0.212891,-0.1113282 -0.0021,-8.825e-4 -0.0038,-0.00303 -0.0059,-0.00391 -0.0057,-0.00235 -0.01187,-0.00358 -0.01758,-0.00586 -0.08447,-0.034214 -0.172627,-0.06174 -0.263672,-0.080078 -0.0039,-7.746e-4 -0.0078,-0.00121 -0.01172,-0.00195 C 30.190043,0.5097298 30.096005,0.5 30,0.5 Z m 1.5,3 h 21 V 14 c 8.2e-5,0.822445 0.677555,1.499918 1.5,1.5 h 10.5 v 29 H 7.5 Z M 31.5,5.6210938 38.378906,12.5 H 31.5 Z M 14,14.5 c -0.822503,0 -1.5,0.677497 -1.5,1.5 0,0.822503 0.677497,1.5 1.5,1.5 h 8 c 0.822503,0 1.5,-0.677497 1.5,-1.5 0,-0.822503 -0.677497,-1.5 -1.5,-1.5 z m 0,10 c -0.822503,0 -1.5,0.677497 -1.5,1.5 0,0.822503 0.677497,1.5 1.5,1.5 h 20 c 0.822503,0 1.5,-0.677497 1.5,-1.5 0,-0.822503 -0.677497,-1.5 -1.5,-1.5 z m 0,10 c -0.822503,0 -1.5,0.677497 -1.5,1.5 0,0.822503 0.677497,1.5 1.5,1.5 h 20 c 0.822503,0 1.5,-0.677497 1.5,-1.5 0,-0.822503 -0.677497,-1.5 -1.5,-1.5 z"
  }))), _symbol120 || (_symbol120 = /*#__PURE__*/React.createElement("symbol", {
    id: "template",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6,0.5 C 5.1775558,0.50008223 4.5000822,1.1775558 4.5,2 v 44 c 8.22e-5,0.822444 0.6775558,1.499918 1.5,1.5 h 36 c 0.822444,-8.2e-5 1.499918,-0.677556 1.5,-1.5 V 14 c 0,-0.096 -0.0097,-0.190043 -0.02734,-0.28125 -7.45e-4,-0.0039 -0.0012,-0.0079 -0.002,-0.01172 -5.26e-4,-0.0026 -0.0014,-0.0052 -0.002,-0.0078 -0.01828,-0.08829 -0.04489,-0.173802 -0.07813,-0.25586 -0.0023,-0.0057 -0.0035,-0.01194 -0.0059,-0.01758 -0.0011,-0.0027 -0.0028,-0.0051 -0.0039,-0.0078 -0.03146,-0.07383 -0.06889,-0.143596 -0.111328,-0.210938 -0.01691,-0.02708 -0.03603,-0.0521 -0.05469,-0.07813 -0.03695,-0.05117 -0.07622,-0.100361 -0.119141,-0.146484 -0.01266,-0.01363 -0.02195,-0.02977 -0.03516,-0.04297 l -12,-11.99999988 c -0.0132,-0.0132017 -0.02933,-0.0225003 -0.04297,-0.0351562 -0.04612,-0.0429174 -0.09532,-0.0821921 -0.146484,-0.11914063 -0.02602,-0.0186601 -0.05104,-0.037778 -0.07813,-0.0546875 -0.06734,-0.0424346 -0.137112,-0.0798633 -0.210938,-0.11132813 -0.0026,-0.001122 -0.0052,-0.002799 -0.0078,-0.003906 -0.0057,-0.002353 -0.01187,-0.003576 -0.01758,-0.005859 -0.08206,-0.0332366 -0.167574,-0.0598473 -0.25586,-0.078125 -0.0026,-5.373e-4 -0.0052,-0.001429 -0.0078,-0.001953 -0.0039,-7.7456e-4 -0.0078,-0.001209 -0.01172,-0.001953 C 30.190043,0.50972979 30.096005,0.5 30,0.5 Z m 1.5,3 h 21 V 14 c 8.2e-5,0.822444 0.677556,1.499918 1.5,1.5 h 10.5 v 29 H 7.5 Z M 31.5,5.6210938 38.378906,12.5 H 31.5 Z"
  }))), _symbol121 || (_symbol121 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 77 78",
    id: "open-modal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.47 0a5.48 5.48 0 0 0 -5.47 5.44v4.56h-3.53a5.5 5.5 0 0 0 -5.47 5.47v57.06a5.5 5.5 0 0 0 5.47 5.47h53.53a2 2 0 1 0 .06-4h-53.59a1.44 1.44 0 0 1 -1.47-1.47v-57.06a1.44 1.44 0 0 1 1.47-1.47h3.53v48.53a5.51 5.51 0 0 0 5.47 5.47h49.53v1a2 2 0 1 0 4 .06v-1.06h3.53a5.51 5.51 0 0 0 5.47-5.47v-57.09a5.48 5.48 0 0 0 -5.47-5.44zm0 4h57.06a1.41 1.41 0 0 1 1.47 1.44v57.09a1.44 1.44 0 0 1 -1.47 1.47h-57.06a1.44 1.44 0 0 1 -1.47-1.47v-57.09a1.41 1.41 0 0 1 1.47-1.44zm8.34 13a2 2 0 0 0 .19 4h40a2 2 0 0 0 .06-4zm0 15a2 2 0 0 0 .19 4h40a2 2 0 0 0 .06-4zm0 15a2 2 0 0 0 .19 4h40a2 2 0 0 0 .06-4zm43.19 27a2 2 0 1 0 2 2 2 2 0 0 0 -2-2z"
  }))), _symbol122 || (_symbol122 = /*#__PURE__*/React.createElement("symbol", {
    id: "add-language",
    viewBox: "0 0 15.08 15.8"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5 3.42 6.86 11.88m7.22-9.17c-2.78 2.49-6.16-.56-8.23 3.08l-3.25-5.63c2.07-3.64 5.47-.58 8.23-3.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.45 11.3v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.45 13.3h4"
  })))), _symbol123 || (_symbol123 = /*#__PURE__*/React.createElement("symbol", {
    id: "filter",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0.5 0.5V3.5L6.5 7.5V15.5L9.5 13.5V7.5L15.5 3.5V0.5H0.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol124 || (_symbol124 = /*#__PURE__*/React.createElement("symbol", {
    id: "attention",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 24h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.44385 8.44385 2.82795 2.82795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 2v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.556 8.44385-2.828 2.82795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 24h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 24c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.223 3.342 9.653 8 11.302v5.698h8v-5.698c4.658-1.649 8-6.079 8-11.302z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 46h8"
  })))), _symbol125 || (_symbol125 = /*#__PURE__*/React.createElement("symbol", {
    id: "blocked",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.9 16.69a.45.45 0 0 1 -.39-.45v-1.85a6.39 6.39 0 1 0 -12.77 0v1.86a.46.46 0 0 1 -.39.45 2.74 2.74 0 0 0 -2.35 2.71v10a2.74 2.74 0 0 0 2.74 2.74h12.77a2.74 2.74 0 0 0 2.74-2.74v-10a2.75 2.75 0 0 0 -2.35-2.72zm-6.78 10.47a1.83 1.83 0 1 1 1.88-1.83 1.83 1.83 0 0 1 -1.83 1.83zm2.29-10.49a.46.46 0 0 0 .45-.46v-1.83a2.74 2.74 0 0 0 -5.47 0v1.83a.46.46 0 0 0 .45.46z",
    fillRule: "evenodd"
  }))), _symbol126 || (_symbol126 = /*#__PURE__*/React.createElement("symbol", {
    id: "video",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 22a10 10 0 1 1 10-10 10 10 0 0 1 -10 10zm0-18.16a8.16 8.16 0 1 0 8.16 8.16 8.17 8.17 0 0 0 -8.16-8.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.61 16.52v-9l7.23 4.48z"
  }))), _symbol127 || (_symbol127 = /*#__PURE__*/React.createElement("symbol", {
    id: "lesson",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.33 23.67 1.67-7.1.1-.1 15.28-15.23a2.41 2.41 0 0 1 3.41 0l2 2a2.4 2.4 0 0 1 0 3.41l-15.36 15.35zm2.57-6.6-1.23 5.26 5.26-1.23 15.16-15.1a1.44 1.44 0 0 0 0-2l-2-2a1.44 1.44 0 0 0 -2 0zm3.75 3.28-3-3 .7-.7 3 3zm13-13-3-3 .7-.7 3 3z"
  }))), _symbol128 || (_symbol128 = /*#__PURE__*/React.createElement("symbol", {
    id: "comment",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.5 1.5h-13c-.552 0-1 .448-1 1v8c0 .552.448 1 1 1h3v4l4.667-4h5.333c.552 0 1-.448 1-1v-8c0-.552-.448-1-1-1z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol129 || (_symbol129 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.21 12.19a.5.5 0 0 0 0-.38.36.36 0 0 0 -.11-.16l-5-5a.49.49 0 0 0 -.7.7l4.14 4.15h-12.29a.5.5 0 0 0 0 1h12.29l-4.14 4.15a.48.48 0 0 0 0 .7.48.48 0 0 0 .7 0l5-5a.36.36 0 0 0 .11-.16z"
  }))), _symbol130 || (_symbol130 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "pointer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 22.8c-.3-.6-.7-1.2-1.2-1.9-2-3.3-6.3-10.2-6.3-12.7 0-4.1 3.4-7.5 7.5-7.5s7.5 3.4 7.5 7.5c0 2.4-3.9 8.8-6.3 12.6 0 0-1.1 1.8-1.2 2z"
  }))), _symbol131 || (_symbol131 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "info"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 5.73a.83.83 0 0 0 -.84.84v5.28a.84.84 0 1 0 1.68 0v-5.28a.84.84 0 0 0 -.84-.84z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4.15,
    r: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 16a8 8 0 1 1 8-8 8 8 0 0 1 -8 8zm0-15a7 7 0 1 0 7 7 7 7 0 0 0 -7-7z"
  }))), _symbol132 || (_symbol132 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "new"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 0a8 8 0 1 0 8 8 8 8 0 0 0 -8-8zm0 14.93a6.93 6.93 0 1 1 6.93-6.93 6.94 6.94 0 0 1 -6.93 6.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.27 7.47h-3.74v-3.74a.53.53 0 1 0 -1.06 0v3.74h-3.74a.53.53 0 0 0 0 1.06h3.74v3.74a.53.53 0 0 0 1.06 0v-3.74h3.74a.53.53 0 1 0 0-1.06z"
  }))), _symbol133 || (_symbol133 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "arrow-right-left"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.85 7.63-3.48-3.48a.52.52 0 1 0 -.74.74l2.59 2.59h-12.44l2.59-2.59a.52.52 0 1 0 -.74-.74l-3.48 3.48a.53.53 0 0 0 0 .74l3.48 3.48a.52.52 0 1 0 .74-.74l-2.59-2.59h12.44l-2.59 2.59a.52.52 0 0 0 .74.74l3.48-3.48a.53.53 0 0 0 0-.74z"
  }))), _symbol134 || (_symbol134 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "save-as-template"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5 8.5h15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 5 3.5 3.5-3.5 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.5 2.5h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.5 14.5h8"
  })))), _symbol135 || (_symbol135 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "arrange"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.5.5v15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.5 12.5-3 3-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.5 2.5v-2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.5 6.5h-2v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.5 4.5v2h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5.5h2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.5 9.5h6v6h-6z"
  })))), _symbol136 || (_symbol136 = /*#__PURE__*/React.createElement("symbol", {
    id: "medical",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.016 12.982v-7.9825h-14.034v7.9831l-7.9824-.000256v14.034h7.983v7.9831h14.034v-7.9831h7.983l-.000256-14.034zm6.8575 12.909h-7.9824v7.9831h-11.783v-7.9831h-7.983v-11.784h7.983v-7.9825h11.783v7.9825l7.9824.000256z",
    strokeWidth: 2
  }))), _symbol137 || (_symbol137 = /*#__PURE__*/React.createElement("symbol", {
    id: "no-img",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.06410616 0 0 .06410616 -10.356498 -5.807666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m172.48 378.84v-73.641l102.2-103.32 67.48 68.039 7.8398-7.8398-71.398-72.238c-2.2383-2.2383-5.8789-2.2383-7.8398 0l-98.281 99.398v-125.44c0-7 5.8789-12.879 12.879-12.879h276.08l11.199-11.199-287.56-.004c-13.16 0-24.078 10.922-24.078 24.078v215.04c0 13.16 10.922 24.078 24.078 24.078h24.078l11.199-11.199-35.277.004c-7 0-12.598-5.8789-12.598-12.879z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512.4 139.72h-7.8398l-11.199 11.199h19.039c7 0 12.879 5.8789 12.879 12.879v164.36l-79.801-80.641c-1.1211-1.1211-2.5195-1.6797-3.9219-1.6797-1.3984 0-2.8008.55859-3.9219 1.6797l-51.234 51.246-20.441-20.719-7.8398 7.8398 104.44 105.56h-210l-11.199 11.199h271.04c13.16 0 24.078-10.922 24.078-24.078l.004-214.76c0-13.441-10.922-24.082-24.082-24.082zm12.883 239.12c0 7-5.8789 12.879-12.879 12.879h-34.16l-84-84.84 47.039-47.32 83.719 84.559v34.723z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.32 438.35 329.05-329.05 7.918 7.918-329.05 329.05z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "pending",
    viewBox: "-35.02 -0.03 24.02 23.9"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7109"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 349.94,301.79 c -11.996,0 -21.855,-9.7383 -21.855,-21.855 v -175.54 c 0,-12.113 9.8594,-21.855 21.855,-21.855 12.113,0 21.855,9.7383 21.855,21.855 v 153.69 h 102.14 c 12.113,0 21.855,9.8594 21.855,21.855 0,12.113 -9.7383,21.855 -21.855,21.855 z M 349.94,0 c 77.32,0 147.39,31.355 197.99,81.953 50.715,50.715 82.07,120.67 82.07,197.99 0,77.32 -31.355,147.39 -82.07,197.99 -50.598,50.715 -120.67,82.07 -197.99,82.07 -77.32,0 -147.27,-31.355 -197.99,-82.07 -50.598,-50.598 -81.953,-120.67 -81.953,-197.99 0,-77.32 31.355,-147.27 81.953,-197.99 C 202.665,31.355 272.62,0 349.94,0 Z M 517.05,112.95 C 474.292,70.192 415.26,43.708 349.94,43.708 c -65.203,0 -124.23,26.484 -166.99,69.242 -42.758,42.758 -69.242,101.79 -69.242,166.99 0,65.324 26.484,124.35 69.242,167.11 42.758,42.758 101.79,69.242 166.99,69.242 65.324,0 124.35,-26.484 167.11,-69.242 42.758,-42.758 69.242,-101.79 69.242,-167.11 0,-65.203 -26.484,-124.23 -69.242,-166.99 z",
    id: "path7007",
    className: "UnoptimicedTransforms",
    style: {
      display: "inline"
    },
    transform: "matrix(0.04285691,0,0,0.04266667,-37.999854,-0.03000115)"
  })), _symbol138 || (_symbol138 = /*#__PURE__*/React.createElement("symbol", {
    id: "email",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,13v6a2,2,0,0,0,2,2H21a2,2,0,0,0,2-2V13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,8V5a2,2,0,0,0-2-2H3A2,2,0,0,0,1,5V8l11,6Z"
  })))), _symbol139 || (_symbol139 = /*#__PURE__*/React.createElement("symbol", {
    id: "toggle-off",
    height: 24,
    viewBox: "0 0 40 24",
    width: 40
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#7a8198",
    height: 16,
    rx: 8,
    width: 32,
    x: 4.10254,
    y: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#fff",
    r: 6
  }))), _symbol140 || (_symbol140 = /*#__PURE__*/React.createElement("symbol", {
    id: "toggle-on",
    height: 24,
    viewBox: "0 0 40 24",
    width: 40
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#3c84f0",
    height: 16,
    rx: 8,
    width: 32,
    x: 4.10254,
    y: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 12,
    fill: "#fff",
    r: 6
  }))), _symbol141 || (_symbol141 = /*#__PURE__*/React.createElement("symbol", {
    id: "data-demo",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 4h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 10h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 21h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 27h12"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m2 2h11v11h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 19h11v11h-11z"
  })))), _symbol142 || (_symbol142 = /*#__PURE__*/React.createElement("symbol", {
    id: "usage",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,5C6.82,5,1,10.82,1,18 s5.82,13,13,13s13-5.82,13-13H14V5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,1v13h13 C31,6.82,25.18,1,18,1z"
  })))), _symbol143 || (_symbol143 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 32 32",
    id: "profile-card"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 15,
    x2: 26,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 20,
    x2: 26,
    y2: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,4c0,1.657-1.343,3-3,3s-3-1.343-3-3h-6c0,1.657-1.343,3-3,3s-3-1.343-3-3h-3c-1.657,0-3,1.343-3,3V25c0,1.657,1.343,3,3,3H28c1.657,0,3-1.343,3-3V7c0-1.657-1.343-3-3-3h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,19c-2.209,0-4,1.791-4,4H14c0-2.209-1.791-4-4-4Z"
  })))), _symbol144 || (_symbol144 = /*#__PURE__*/React.createElement("symbol", {
    id: "lock",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34 16v-4a10.029 10.029 0 0 0 -10-10 10.029 10.029 0 0 0 -10 10v4"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 25,
    rx: 4,
    width: 36,
    x: 6,
    y: 21
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 31,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 35v5"
  }))))), _symbol145 || (_symbol145 = /*#__PURE__*/React.createElement("symbol", {
    id: "unlock",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.158 8c-1.548-3.524-5.064-5.988-9.158-6-5.516.016-9.984 4.484-10 10v4"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 25,
    rx: 4,
    width: 36,
    x: 6,
    y: 21
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 31,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 35v5"
  }))))), _symbol146 || (_symbol146 = /*#__PURE__*/React.createElement("symbol", {
    id: "setup-preferences",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 9h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 9h-22"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 9,
    r: 6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m45 24h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 24h-22"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 24,
    r: 6
  })), /*#__PURE__*/React.createElement("path", {
    d: "m6 39h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 39h-22"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 39,
    r: 6
  })))), _symbol147 || (_symbol147 = /*#__PURE__*/React.createElement("symbol", {
    id: "archive-drawer",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 14h42v31h-42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 8h28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 2h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 23v4h-18v-4"
  })))), _symbol148 || (_symbol148 = /*#__PURE__*/React.createElement("symbol", {
    id: "users-settings",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.819 30.734-.358-2.508c4.872 1.107 7.539-.226 7.539-.226a18.983 18.983 0 0 1 -3-9v-1.726a8.182 8.182 0 0 0 -7.467-8.257 8 8 0 0 0 -8.533 7.983v2a18.983 18.983 0 0 1 -3 9s2.667 1.333 7.539.226l-.358 2.508a2 2 0 0 1 -1.4 1.633l-6.643 1.992a3 3 0 0 0 -2.138 2.873v4.768h28v-4.768a3 3 0 0 0 -2.138-2.873l-6.638-1.992a2 2 0 0 1 -1.405-1.633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 42h10v-6.9a3 3 0 0 0 -1.975-2.819l-7.9-2.872a2 2 0 0 1 -1.3-1.6l-.506-3.543a7.994 7.994 0 0 0 4.681-7.266v-5.927a4.367 4.367 0 0 0 -4.364-4.364l-1.129-2.259a.843.843 0 0 0 -1.007-.406l-5.388 1.923a5.6 5.6 0 0 0 -1.738 1.033"
  })))), _symbol149 || (_symbol149 = /*#__PURE__*/React.createElement("symbol", {
    id: "school-settings",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24 14v-12h8v6h-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 46v-10h-8v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 30v-8l-10-8-10 8v8h-12v16h44v-16z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m8 36h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 25h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 36h4v4h-4z"
  }))))), _symbol150 || (_symbol150 = /*#__PURE__*/React.createElement("symbol", {
    id: "checked-all",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z",
    fill: "currentColor"
  }))), _symbol151 || (_symbol151 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-single",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "3.5 8.5 6 11 12.5 4.5"
  })))), _symbol152 || (_symbol152 = /*#__PURE__*/React.createElement("symbol", {
    id: "qr-code",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 7,
    height: 7,
    stroke: "currentColor",
    "data-cap": "butt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 3,
    width: 7,
    height: 7,
    stroke: "currentColor",
    "data-cap": "butt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 7,
    height: 7,
    stroke: "currentColor",
    "data-cap": "butt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14H18M19 14V19H21M19 14H21M19 14H18M18 14V16H16",
    stroke: "currentColor",
    "data-color": "color-2",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 18V21H17",
    stroke: "currentColor",
    "data-color": "color-2",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5H6.51",
    stroke: "currentColor",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.5H6.51",
    stroke: "currentColor",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.49 6.5H17.5",
    stroke: "currentColor",
    fill: "none"
  })))), _symbol153 || (_symbol153 = /*#__PURE__*/React.createElement("symbol", {
    id: "clear",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,13.5H14A1.5,1.5,0,0,0,15.5,12V4A1.5,1.5,0,0,0,14,2.5H5.5L.5,8Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    "data-color": "color-2",
    x1: 7.5,
    y1: 5.5,
    x2: 12.5,
    y2: 10.5,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    "data-color": "color-2",
    x1: 12.5,
    y1: 5.5,
    x2: 7.5,
    y2: 10.5,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprites);
export default __webpack_public_path__ + "static/media/sprites.55bfe9acad1563329c033777aae21e0d.svg";
export { ForwardRef as ReactComponent };